import { useContext } from "react";
import { MdArrowBack, MdArrowForward } from "react-icons/md";
import { AppContext } from "../App";
import { MotionGroup, MotionItem, MotionReveal, MotionText } from "../components/MotionReveal";
import PageHero from "./PageHero";
import { getProjectBySlug, projects } from "./ProjectsContent";

export default function OneProject(props) {
  const { projectSlug } = props;
  const appContext = useContext(AppContext);
  const project = getProjectBySlug(projectSlug) || projects[0];

  const details = [
    { label: "Year / Status", value: project.status },
    { label: "Client", value: project.client },
    { label: "Role", value: project.role },
    { label: "Location", value: project.location },
    { label: "Value", value: project.value },
    { label: "Category", value: project.category },
  ].filter((detail) => detail.value);

  return (
    <>
      <PageHero
        eyebrow="Project"
        title={project.name}
        text={project.description}
        image={project.image}
      />

      <section className="tgm-section tgm-project-detail">
        <div className="container">
          <MotionReveal
            as="button"
            type="button"
            className="tgm-project-back"
            onClick={() => appContext.navTo({ item: "projects" })}
            variant="left"
            whileHover={{ x: -4 }}
            whileTap={{ scale: 0.96 }}
          >
            <MdArrowBack /> Back to projects
          </MotionReveal>

          <div className="tgm-project-detail-layout">
            <MotionGroup className="tgm-project-detail-copy" stagger={0.08}>
              <MotionReveal
                as="p"
                className="tgm-section-kicker"
                variant="soft"
              >
                Project Overview
              </MotionReveal>
              <MotionText as="h2" text={project.category} />
              <MotionReveal as="p" variant="soft">
                {project.description}
              </MotionReveal>

              <MotionGroup className="tgm-project-detail-grid" stagger={0.08}>
                {details.map((detail) => (
                  <MotionItem
                    className="tgm-project-detail-stat"
                    variant="card"
                    key={detail.label}
                  >
                    <span>{detail.label}</span>
                    <strong>{detail.value}</strong>
                  </MotionItem>
                ))}
              </MotionGroup>
            </MotionGroup>

            <MotionReveal className="tgm-project-detail-feature" variant="image">
              <img src={project.image} alt={project.name} />
            </MotionReveal>
          </div>

          <div className="tgm-project-gallery">
            <MotionGroup className="tgm-section-head" stagger={0.08}>
              <div>
                <MotionReveal
                  as="p"
                  className="tgm-section-kicker"
                  variant="soft"
                >
                  Project Images
                </MotionReveal>
              </div>
            </MotionGroup>

            <MotionGroup className="tgm-project-gallery-grid" stagger={0.08}>
              {project.images.map((image, index) => (
                <MotionItem
                  as="figure"
                  variant="image"
                  className="tgm-project-gallery-item"
                  key={`${project.slug}-${index}`}
                >
                  <img src={image} alt={`${project.name} ${index + 1}`} />
                </MotionItem>
              ))}
            </MotionGroup>
          </div>

          <MotionReveal className="tgm-project-next" variant="card">
            <div>
              <span>Need a similar project handled?</span>
              <strong>Talk to SNJ Tanzania Limited about your scope.</strong>
            </div>
            <button
              type="button"
              className="tgm-solid-btn"
              onClick={() => appContext.navTo({ item: "contact_us" })}
            >
              Contact us <MdArrowForward />
            </button>
          </MotionReveal>
        </div>
      </section>
    </>
  );
}
